"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeGeolocation = void 0;
var TypeGeolocation;

(function (TypeGeolocation) {
  /**
   * 유저의 현재 위치를 요청해요
   */
  TypeGeolocation["ReqGeolocationCurrentPosition"] = "REQ.GEOLOCATION.CURRENT_POSITION";
})(TypeGeolocation = exports.TypeGeolocation || (exports.TypeGeolocation = {}));